function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createOperationDescriptor, getRequest } from 'relay-runtime';
var QuerySubscription = /*#__PURE__*/function () {
  function QuerySubscription(_ref) {
    var _this = this;
    var environment = _ref.environment,
      query = _ref.query,
      variables = _ref.variables,
      cacheConfig = _ref.cacheConfig,
      fetchPolicy = _ref.fetchPolicy;
    _classCallCheck(this, QuerySubscription);
    this.onChange = function (snapshot) {
      _this.updateReadyState({
        error: null,
        props: snapshot.data,
        retry: _this.retry
      });
    };
    this.retry = function () {
      _this.retrying = true;
      _this.retryingAfterError = !!_this.readyState.error;
      _this.dispose(); // eslint-disable-next-line @typescript-eslint/no-empty-function

      _this.execute(function () {});
    };
    this.environment = environment;
    this.query = query;
    this.variables = variables;
    this.cacheConfig = cacheConfig;
    this.fetchPolicy = fetchPolicy;
    this.operation = createOperationDescriptor(getRequest(query), variables, cacheConfig);
    this.fetchPromise = null;
    this.selectionReference = null;
    this.pendingRequest = null;
    this.rootSubscription = null;
    this.retrying = false;
    this.retryingAfterError = false;
    this.readyState = {
      error: null,
      props: null,
      retry: null
    };
    this.listeners = [];
    this.relayContext = {
      environment: this.environment,
      variables: this.operation.request.variables
    };
  }
  return _createClass(QuerySubscription, [{
    key: "updateCacheConfig",
    value: function updateCacheConfig(nextCacheConfig) {
      if (this.cacheConfig !== nextCacheConfig) {
        this.cacheConfig = nextCacheConfig;
        this.operation = createOperationDescriptor(getRequest(this.query), this.variables, this.cacheConfig);
      }
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var _this2 = this;
      if (!this.fetchPromise) {
        this.fetchPromise = new Promise(function (resolve) {
          _this2.execute(resolve);
        });
      }
      return this.fetchPromise;
    }
  }, {
    key: "execute",
    value: function execute(resolve) {
      var _this3 = this;
      var snapshot;
      this.selectionReference = this.retain();
      var onSnapshot = function onSnapshot() {
        if (snapshot) {
          return;
        }
        snapshot = _this3.environment.lookup(_this3.operation.fragment);
        _this3.onChange(snapshot);
        _this3.rootSubscription = _this3.environment.subscribe(snapshot, _this3.onChange);
        resolve();
      };
      var onError = function onError(error) {
        _this3.updateReadyState({
          error: error,
          props: null,
          retry: _this3.retry
        });
        resolve();
      };
      var useStoreSnapshot = !this.retrying && (this.fetchPolicy === 'store-and-network' || this.fetchPolicy === 'store-or-network') && this.environment.check(this.operation).status === 'available';
      if (!(this.fetchPolicy === 'store-or-network' && useStoreSnapshot)) {
        try {
          this.pendingRequest = this.environment.execute({
            operation: this.operation
          })["finally"](function () {
            _this3.pendingRequest = null;
          }).subscribe({
            next: onSnapshot,
            error: onError
          });
        } catch (error) {
          onError(error);
          return;
        }
      } // Only use the store snapshot if the network layer doesn't synchronously
      // resolve a snapshot, to match <QueryRenderer>.

      if (!snapshot && useStoreSnapshot) {
        onSnapshot();
      }
      if (!snapshot && this.retryingAfterError) {
        this.updateReadyState({
          error: null,
          props: null,
          retry: null
        });
      }
    }
  }, {
    key: "updateReadyState",
    value: function updateReadyState(readyState) {
      this.readyState = readyState;
      this.listeners.forEach(function (listener) {
        listener();
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(listener) {
      this.listeners.push(listener);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(listener) {
      this.listeners = this.listeners.filter(function (item) {
        return item !== listener;
      });
    }
  }, {
    key: "retain",
    value: function retain() {
      return this.environment.retain(this.operation);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.fetchPromise = null;
      if (this.selectionReference) {
        this.selectionReference.dispose();
      }
      if (this.pendingRequest) {
        this.pendingRequest.unsubscribe();
      }
      if (this.rootSubscription) {
        this.rootSubscription.dispose();
      }
    }
  }, {
    key: "getQueryName",
    value: function getQueryName() {
      return this.operation.root.node.name;
    }
  }]);
}();
export { QuerySubscription as default };